import { render, staticRenderFns } from "./plan-details.vue?vue&type=template&id=61d16e3e&scoped=true"
import script from "./plan-details.vue?vue&type=script&lang=js"
export * from "./plan-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d16e3e",
  null
  
)

export default component.exports